import React, { FC, memo, useCallback, useMemo } from "react";
import CPlaceMark from "../CPlaceMark";
import { IBusStation } from "@/shared/types/busStaition";
import imgBusStop from "../../../../../assets/images/busStopInCircle.svg";
import imgActive from "../../../../../assets/images/busStopInCircleActive.svg";
import imgTramActive from "../../../../../assets/images/red-staition.svg";
import imgTram from "../../../../../assets/images/red-staition1.svg";

interface Props {
  data: IBusStation;
  size: [number, number];
  mapMode: string;
  isActive?: boolean;
  onClick: (s: IBusStation) => void;
}

const PlacemarkBusStationInner: FC<Props> = ({ data, size, isActive, onClick }) => {
  const isTram = data.transport_type === "ТРАМВАЙ";

  const iconImageHref = useMemo(() => {
    if (isActive) return isTram ? imgTramActive : imgActive;
    return isTram ? imgTram : imgBusStop;
  }, [isActive, isTram]);

  const geometry = useMemo(
    () => [Number(data.stop_latitude), Number(data.stop_longitude)] as [number, number],
    [data.stop_latitude, data.stop_longitude]
  );

  const handleClick = useCallback(() => onClick(data), [onClick, data]);

  return (
    <CPlaceMark
      iconImageHref={iconImageHref}
      geometry={geometry}
      hintContent={data.name}
      handlePlacemarkClick={handleClick}
      iconImageSize={isActive ? [30, 30] : size}
      zIndex={isActive ? 10_000 : 1}
      zIndexHover={isActive ? 10_001 : 2}
    />
  );
};

// comparator: ререндерим только если реально поменялось то, что влияет на метку
export default memo(PlacemarkBusStationInner, (prev, next) => {
  const a = prev.data;
  const b = next.data;

  return (
    prev.isActive === next.isActive &&
    prev.mapMode === next.mapMode &&
    prev.size[0] === next.size[0] &&
    prev.size[1] === next.size[1] &&
    a.id === b.id &&
    a.transport_type === b.transport_type &&
    a.stop_latitude === b.stop_latitude &&
    a.stop_longitude === b.stop_longitude &&
    a.name === b.name
  );
});